/**
 * Mando UI initialisation
 */

/* eslint-disable */
import polyfillClosest from './polyfill';
import cookieBanner from 'Components/default/notices/cookie/mando-ui.cookie';
import navigation from 'Components/default/navigation/primary/mando-ui.navigation';
import navbar from 'Components/default/navigation/_navbar/mando-ui.navbar';
import share from 'Components/default/share/mando-ui.share';
import rteTable from 'Components/default/rte/mando-ui.rte-table';
import blog from 'Components/default/blog-listing/mando-ui.blog-listing';
import analytics from './mando-lib.analytics';
import kbuser from './mando-lib.kb-user';
import video from 'Components/default/video/video-item/mando-ui.video-item';
import modal from 'Components/default/modal/mando-ui.modal';

document.addEventListener("DOMContentLoaded", function () {
  // Add JS helper class
  document.getElementsByTagName('html')[0].classList.remove('no-js');
  document.getElementsByTagName('html')[0].classList.add('has-js');

  // Polyfill
  polyfillClosest();

  // Components
  cookieBanner();
  navigation();
  navbar();
  share();
  rteTable();
  blog();
  modal();
  video();
  analytics();
  kbuser();
});



// WEBPACK FOOTER //
// ./src/scripts/app.js